import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { NavigationService } from '../common/services/navigation.service';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss']
})
export class SideNavigationComponent implements OnInit {
  @Output() hide: EventEmitter<void>;
  @Input() sections: MenuItem[];
  @Input() currentSection: string;

  constructor(
    private elRef: ElementRef,
    private navigationService: NavigationService
  ) {
    this.hide = new EventEmitter<void>();
    this.navigationService.hideSideMenu$().subscribe(shouldHide => {
      if (shouldHide) {
        this.triggerHide();
      }
    });
  }

  ngOnInit(): void {
  }

  triggerHide() {
    this.hide.next();
  }

  isSectionActive(section: string): boolean {
    return this.currentSection === section;
  }

  @HostListener('document:click', ['$event'])
  processClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.hide.next();
    }
  }
}
